/**
 * @generated SignedSource<<a435ebe4987837ace630b79db5c8e3b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteClientNutritionTargetInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ClientNutritionTargetDrawerDeleteMutation$variables = {
  input: DeleteClientNutritionTargetInput;
};
export type ClientNutritionTargetDrawerDeleteMutation$data = {
  readonly deleteClientNutritionTarget: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type ClientNutritionTargetDrawerDeleteMutation = {
  response: ClientNutritionTargetDrawerDeleteMutation$data;
  variables: ClientNutritionTargetDrawerDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteClientNutritionTargetPayload",
    "kind": "LinkedField",
    "name": "deleteClientNutritionTarget",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientNutritionTargetDrawerDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientNutritionTargetDrawerDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "280e46c7d33cd702382852120f35071b",
    "id": null,
    "metadata": {},
    "name": "ClientNutritionTargetDrawerDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ClientNutritionTargetDrawerDeleteMutation(\n  $input: DeleteClientNutritionTargetInput!\n) {\n  deleteClientNutritionTarget(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1d8a042696385222085ae6cd204d398";

export default node;
